import { render, staticRenderFns } from "./NsSearch.vue?vue&type=template&id=ca520e64&scoped=true&"
import script from "./NsSearch.vue?vue&type=script&lang=js&"
export * from "./NsSearch.vue?vue&type=script&lang=js&"
import style0 from "./NsSearch.vue?vue&type=style&index=0&id=ca520e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca520e64",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
